export default __webpack_public_path__ + "static/media/expert_data.0889df60.png";